import { SUPABASE_URL } from "@/lib/supabase";

/**
 * VIB-524/VIB-647: returnerer true når Supabase-klienten peker mot en
 * preview-branch eller annet ikke-prod-miljø. Brukes av EnvironmentBanner
 * for å vise "TESTMILJØ"-banner øverst i appen.
 *
 * Hooken er en ren read av SUPABASE_URL-konstanten — den abonnerer ikke
 * på endringer (URLen settes ved build, ikke runtime), så den trenger
 * verken React Query eller useState. Den finnes som hook for å holde
 * komponentene unna direkte supabase-import (CLAUDE.md §4).
 */
const PROD_PROJECT_REF = "rddghbviygpxympocxak";

export function useIsTestEnvironment(): boolean {
  if (!SUPABASE_URL) return false;
  return !SUPABASE_URL.includes(PROD_PROJECT_REF);
}
